
    <i
      class="fa fa-2x fa-arrow-circle-o-left text-dark"
      (click)="back($event)"
    ></i>
  